export default __webpack_public_path__ + "static/media/RT-4.0a64cff8.png";